import { CUSTOM_ELEMENTS_SCHEMA, Component } from '@angular/core';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { lucidePhone } from '@ng-icons/lucide';

import { PHONE_HOURS, PHONE_NUMBERS, PhoneHours } from 'app/common/constants/contact-constants';
import { PhonePipe } from 'app/common/pipes/phone-number/phone.pipe';

@Component({
  selector: 'app-header',
  imports: [NgIconComponent, PhonePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <header class="bg-neutral-900 print:hidden" data-testid="main-header">
      <div class="container flex items-center justify-between px-4 py-3">
        <!-- NOTE: We want the referrer for analytics -->
        <a href="https://www.kin.com" rel="noopener" class="p-1 outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-neutral-900" aria-label="navigate to homepage">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="h-400 text-primary sm:h-600" data-testid="company-logo" viewBox="0 0 73 40">
            <path
              fill="currentColor"
              d="M68.74 31.781c2.176 0 3.892 1.732 3.892 3.844s-1.732 3.844-3.892 3.844c-2.112 0-3.78-1.732-3.78-3.844s1.668-3.844 3.78-3.844ZM51.38 16.264c7.037 0 9.88 5.29 9.88 11.102v10.705c0 .556-.493 1.064-1.05 1.064h-4.557c-.603 0-1.048-.508-1.048-1.064V27.032c0-2.89-1.493-4.733-4.162-4.733-2.89 0-4.67 2.002-5.225 3.51v12.262c0 .778-.334 1.064-1.382 1.064h-4.113c-.556 0-1.048-.508-1.048-1.064V17.884c0-.62.492-1.065 1.048-1.065h2.112c.492 0 .779.271.938.668l.778 2.065c.842-.89 3.558-3.288 7.83-3.288Zm-19.218.476c.54 0 1.049.445 1.049 1.065V37.99c0 .556-.493 1.065-1.049 1.065h-4.605c-.556 0-1.05-.509-1.05-1.065V17.805c0-.62.494-1.065 1.05-1.065h4.605ZM5.782 0c.555 0 1.047.509 1.047 1.064v24.158l7.275-7.815c.38-.333.778-.667 1.381-.667h5.051c.937 0 1.27 1 .715 1.62l-8.274 8.482 9.878 10.641c.556.604.223 1.557-.714 1.557h-6.004c-.334 0-.778-.223-.937-.445L6.813 28.557v9.419c0 .555-.492 1.064-1.047 1.064H1.048C.492 39.04 0 38.531 0 37.976V1.064C0 .51.492 0 1.048 0H5.78ZM29.78 5.099c2.176 0 3.89 1.731 3.89 3.843 0 2.113-1.73 3.843-3.89 3.843-2.112 0-3.78-1.73-3.78-3.843C26 6.83 27.668 5.1 29.78 5.1Z"
              clip-rule="evenodd"
            />
          </svg>
        </a>

        <div class="flex flex-col items-end">
          <span class="hidden text-0 font-semibold text-neutral-50 sm:block">Talk to a licensed agent:</span>
          <div class="my-1 flex items-center text-primary">
            <ng-icon name="lucidePhone" class="flex h-[1.2em] w-[1.2em] md:h-[1em] md:w-[1em]" aria-hidden="true"></ng-icon>
            <a
              href="tel:{{ phoneNumber }}"
              class="ml-1 text-center text-body-md font-semibold outline-none focus:ring-2 focus:ring-primary sm:text-body-sm"
              aria-label="contact an agent"
              data-testid="contact-agent-button"
              >{{ phoneNumber | phone }}</a
            >
          </div>
          <div class="hidden text-right text-[0.6875rem] leading-[1.46] text-neutral-50 sm:block" data-testid="agent-hours">
            <div class="">Mon - Fri, {{ hours.salesMF }}</div>
            <div class="">Sat, {{ hours.salesSat }}</div>
          </div>
        </div>
      </div>
    </header>
  `,
  providers: [provideIcons({ lucidePhone })],
})
export class HeaderComponent {
  /**
   * @todo - improve this to show hours/phone based on locale
   */
  readonly hours: PhoneHours = PHONE_HOURS;
  readonly phoneNumber = PHONE_NUMBERS.sales;
}
